import { DocumentosComponent } from './sos/documentos/documentos.component';
import { SosComponent } from './sos/sos.component';
import { ObservacaoComponent } from './sos/observacao/observacao.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from '../../../shared/breadcrumb/breadcrumb.module';
import { SharedModule } from '../../../shared/shared.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { CardTimelineComponent } from './card-timeline/card-timeline.component';
import { BannerTimelineComponent } from './banner-timeline/banner-timeline.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../../../directives/directives.module';
import { TextDirectivesModule } from '../../../directives/texto/text.directives.module';
import { MotivoDesistenciaComponent } from './motivo-desistencia/motivo-desistencia.component';
import { SosInversoComponent } from './sos-inverso/sos-inverso.component';
import { CardAssinaturaComponent } from './card-assinatura/card-assinatura.component';
import { ModalAssinaturaComponent } from './modal-assinatura/modal-assinatura.component';
import { ModalAlterarEmailComponent } from './modal-alterar-email/modal-alterar-email.component';
import { ModalDocusignComponent } from './modal-docusign/modal-docusign.component';
import { CreditoPessoalTimelineComponent } from './cp-timeline.component';
import { CreditoPessoalService } from '../services/cp.service';

@NgModule({
  declarations: [
    CreditoPessoalTimelineComponent,
    CardTimelineComponent,
    BannerTimelineComponent,
    MotivoDesistenciaComponent,
    SosInversoComponent,
    ObservacaoComponent,
    DocumentosComponent,
    SosComponent,
    CardAssinaturaComponent,
    ModalAssinaturaComponent,
    ModalAlterarEmailComponent,
    ModalDocusignComponent,
  ],
  imports: [
    CommonModule,
    BreadcrumbModule,
    SharedModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    TextDirectivesModule,
    NgxMaskModule.forRoot()
  ],
  entryComponents: [
    MotivoDesistenciaComponent,
    ModalAssinaturaComponent,
    ModalAlterarEmailComponent,
    ModalDocusignComponent,
  ],
  providers: [
    CreditoPessoalService
  ]
})
export class CreditoPessoalTimelineModule { }
